import { render, staticRenderFns } from "./BooleanParameterType.vue?vue&type=template&id=610b2f65&scoped=true&"
import script from "./BooleanParameterType.vue?vue&type=script&lang=js&"
export * from "./BooleanParameterType.vue?vue&type=script&lang=js&"
import style0 from "./BooleanParameterType.vue?vue&type=style&index=0&id=610b2f65&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610b2f65",
  null
  
)

export default component.exports